import { RefObject, useCallback } from 'react';

import useClickOutside from 'common/helpers/useClickOutside';

type useCloseOutsideProps = {
  refs: RefObject<any>[];
  deps?: any[];
  setOpen: (value: boolean) => void;
  isOpen: boolean;
};

const useCloseOutside = ({
  refs,
  setOpen,
  isOpen,
  deps,
}: useCloseOutsideProps) =>
  useClickOutside(
    refs,
    useCallback(() => {
      if (isOpen) {
        setOpen(false);
      }
    }, [isOpen, setOpen]),
    deps,
  );

export default useCloseOutside;
